import React, { useState } from "react";
import CchubLogo from "../assets/images/cchub-logo.png";
import HeroEllipsePatterns from "../assets/images/hero-section-ellipses.svg";
import EmailModal from "./EmailModal";
import { saveEmail } from "../api/emails";

const HeroSection: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleEmailSubmit = async (email: string) => {
    await saveEmail(email);
    const link = document.createElement("a");
    link.href = "/cchub-impact-report.pdf";
    link.download = "CcHUB 2025 Impact Report.pdf";
    link.click();
  };

  return (
    <>
      <section id="hero-section">
        <img src={HeroEllipsePatterns} alt="" className="hero-patterns-left" />
        <img src={HeroEllipsePatterns} alt="" className="hero-patterns-right" />
        <div className="hero-header">
          <img src={CchubLogo} alt="cchub-logo" />
          <a href="#" onClick={handleDownloadClick}>
            <button className="download-report-button">Download Report</button>
          </a>
        </div>
        <div className="hero-body">
          <p id="hero-mini-title">CcHUB 2025 IMPACT REPORT</p>
          <h1>
            Stories of <span className="orange-highlight">Change</span>
          </h1>

          <p>
            Building the conditions for African prosperity across education,
            health, and creative industries in 49 countries.
          </p>
        </div>
        <a href="#" onClick={handleDownloadClick}>
          <button
            className="download-report-button"
            id="mobile-download-button"
          >
            Download Report
          </button>
        </a>
      </section>
      <EmailModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleEmailSubmit}
      />
      <div className="hero-transition" />
    </>
  );
};

export default HeroSection;
